import { render, staticRenderFns } from "./Contactgegevens.vue?vue&type=template&id=1fcd3e71&"
import script from "./Contactgegevens.vue?vue&type=script&lang=js&"
export * from "./Contactgegevens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports